/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var kendo_licensing_1 = require("@progress/kendo-licensing");
var package_metadata_1 = require("../package-metadata");
var date_range_popup_component_1 = require("./date-range-popup.component");
var date_range_service_1 = require("./date-range.service");
/**
 * Represents the Kendo UI DateRange component for Angular.
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-daterange>
 *      <kendo-dateinput kendoDateRangeStartInput [(value)]="dateRange.start"></kendo-dateinput>
 *      <kendo-dateinput kendoDateRangeEndInput [(value)]="dateRange.end"></kendo-dateinput>
 *  </kendo-daterange>
 * `
 * })
 * export class AppComponent {
 *   public dateRange: any = { start: null, end: null };
 * }
 * ```
 */
var DateRangeComponent = /** @class */ (function () {
    function DateRangeComponent() {
        /**
         * @hidden
         */
        this.showDefault = false;
        kendo_licensing_1.validatePackage(package_metadata_1.packageMetadata);
    }
    Object.defineProperty(DateRangeComponent.prototype, "hasContentPopup", {
        get: function () {
            return this.contentPopup.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    DateRangeComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.showDefault = !this.hasContentPopup;
        this.subscription = this.contentPopup.changes.subscribe(function () {
            _this.showDefault = !_this.hasContentPopup;
        });
    };
    DateRangeComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    tslib_1.__decorate([
        core_1.ContentChildren(date_range_popup_component_1.DateRangePopupComponent),
        tslib_1.__metadata("design:type", core_1.QueryList)
    ], DateRangeComponent.prototype, "contentPopup", void 0);
    DateRangeComponent = tslib_1.__decorate([
        core_1.Component({
            providers: [date_range_service_1.DateRangeService],
            selector: 'kendo-daterange',
            template: "\n        <ng-content></ng-content>\n        <kendo-daterange-popup *ngIf=\"showDefault\"></kendo-daterange-popup>\n    "
        }),
        tslib_1.__metadata("design:paramtypes", [])
    ], DateRangeComponent);
    return DateRangeComponent;
}());
exports.DateRangeComponent = DateRangeComponent;
